import React, { Component, ReactNode } from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import styled from "styled-components";

import {
	isChunkLoadError,
	markNewBuild,
	UPDATE_NOTICE_TEXT_KEY,
} from "./newBuild";
import { NoticeBox, NoticeText, ReloadButton, reload } from "./styles";

const Center = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;

	width: 100%;
	height: 100%;
`;

type Props = WithTranslation & {
	children: ReactNode;
};

type State = {
	error: unknown;
};

/**
 * After a deploy the old lazy chunks are gone, so opening a page this tab
 * has not loaded yet fails. Here that page shows «press F5» and the header
 * keeps working. Any other error goes up as before.
 */
class UpdateNoticeBoundary extends Component<Props, State> {
	state: State = { error: null };

	static getDerivedStateFromError(error: unknown): State {
		return { error };
	}

	// eslint-disable-next-line class-methods-use-this
	componentDidCatch(error: unknown) {
		if (isChunkLoadError(error)) markNewBuild();
	}

	render() {
		const { error } = this.state;
		if (!error) return this.props.children;
		if (!isChunkLoadError(error)) throw error;

		const { t } = this.props;
		const text = t(`${UPDATE_NOTICE_TEXT_KEY}.text`);
		return (
			<Center>
				<NoticeBox role="alert">
					<NoticeText title={text}>{text}</NoticeText>
					<ReloadButton type="button" onClick={reload}>
						{t(`${UPDATE_NOTICE_TEXT_KEY}.reload`)}
					</ReloadButton>
				</NoticeBox>
			</Center>
		);
	}
}

export default withTranslation()(UpdateNoticeBoundary);
